import { JsonDiscriminatorValue, JsonObject } from "ta-json";

import DataType from "../data-type";
import { PropertyDefinition } from "../property-definition";

/**
 * Decimal property definition.
 */
@JsonObject()
@JsonDiscriminatorValue(DataType.Decimal)
export class DecimalPropertyDefinition extends PropertyDefinition {
    constructor(name: string, init?: Omit<Partial<DecimalPropertyDefinition>, "name">) {
        super(name, DataType.Decimal);
        Object.assign(this, init);
    }
}
